module.exports = __webpack_public_path__ + "img/company.89fa67b3.png";